import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { Route, Switch } from 'react-router-dom';
import AppLayout from '@afosto/components-react/AppLayout';
import AppWorkspace from '@afosto/components-react/AppWorkspace';
import Dock from '@afosto/app-components-react/Dock';
import Drawer from '@afosto/app-components-react/Drawer';
import DrawerMenu from '@afosto/app-components-react/DrawerMenu';
import AppStore from '../pages/AppStore';
import AuditLog from '../pages/AuditLog';
import Channels from '../pages/Channels';
import Contract from '../pages/Contract';
import ExternalAccess from '../pages/ExternalAccess';
import IdealCallback from '../pages/IdealCallback';
import Integrations from '../pages/Integrations';
import OauthClients from '../pages/OauthClients';
import Overview from '../pages/Overview';
import Profile from '../pages/Profile';
import Rbac from '../pages/Rbac';
import Settings from '../pages/Settings';
import Users from '../pages/Users';
import ViewChannel from '../pages/ViewChannel';
import ViewIntegration from '../pages/ViewIntegration';
import ViewOauthClient from '../pages/ViewOauthClient';
import ViewPurgeRequest from '../pages/ViewPurgeRequest';
import menu from '../data/navigationMenu';
import translations from './translations';

const Root = () => {
  const intl = useIntl();

  return (
    <AppLayout>
      <Drawer>
        <Dock />
        <DrawerMenu title={intl.formatMessage(translations.drawer.title)} menu={menu} />
      </Drawer>
      <AppWorkspace>
        <Switch>
          <Route exact path="/" component={Overview} />
          <Route path="/profile" component={Profile} />
          <Route path="/users" component={Users} />
          <Route path="/external-access" component={ExternalAccess} />
          <Route path="/rbac" component={Rbac} />
          <Route path="/audit-log" component={AuditLog} />
          <Route path="/oauth-clients/:id" component={ViewOauthClient} />
          <Route path="/oauth-clients" component={OauthClients} />
          <Route path="/channels/:id" component={ViewChannel} />
          <Route path="/channels" component={Channels} />
          <Route path="/store" component={AppStore} />
          <Route path="/integrations/:id" component={ViewIntegration} />
          <Route path="/integrations" component={Integrations} />
          <Route path="/contract" component={Contract} />
          <Route path="/payment-method/ideal/callback" component={IdealCallback} />
          <Route path="/settings" component={Settings} />
          <Route path="/purge/:token" component={ViewPurgeRequest} />
        </Switch>
      </AppWorkspace>
    </AppLayout>
  );
};

export default Root;
